export default __webpack_public_path__ + "static/media/user-picture.d18f3b25.svg";